import { Vue } from "vue-property-decorator";
import * as questions from "../../questions.json";
import { QuestionFlow } from "../models/questionFlow";

export const QuestionFlowService = new Vue({
  methods: {
    createFlow() {
      const flow = new QuestionFlow(questions);
      return flow;
    },
  },
});